// extracted by mini-css-extract-plugin
export default {"root":"ItemHolder_root__MDkCR","flex":"ItemHolder_flex__a6yoz"};